<template>
  <gj-modal
    size="table"
    :visible.sync="modalVisible"
    :confirmLoading="confirmLoading"
    @cancel="cancel"
    @confirm="confirm"
  >
    <template #header>编辑标签</template>
    <template #content>
      <div class="marBottom">
        <el-row type="flex">
          <el-col :span="2"><span class="boldSpan">评论内容：</span></el-col>
          <el-col>{{ tag.comments }}</el-col>
        </el-row>
      </div>
      <template>
        <span class="boldSpan marBottom">所含商品：</span>
        <el-row type="flex" class="gj-picker">
          <div class="gj-picker__editor">
            <div class="gj-picker__editor--body">
              <gj-table
                ref="gjTable"
                :index="false"
                :adapt-height="false"
                :height="370"
                :data="tableData"
                stripe
                :show-overflow="false"
                :loading="loading"
                :columns="columns0"
                :highlightCurrentRow="true"
                @current-change="clickRow"
              >
                <template v-slot:listingTitle="{ index, row }">
                  <div style="margin: 4px 0">
                    <gj-tooltip :text-line="1" :content="row.listingTitle">
                      {{ row.listingTitle | defaultShow }}
                    </gj-tooltip>
                    <el-row v-if="false" type="flex" align="middle" v-gutter="8">
                      <gj-rate
                        :value="row.star"
                        disabled
                        style="display: inline"
                        text-color="#ff9900"
                      >
                      </gj-rate>
                      <span>({{ row.star }})</span>
                      <el-divider direction="vertical"></el-divider>
                      <span style="color: #cc0000">${{ row.price | defaultShow }}</span>
                    </el-row>
                    <el-row style="color: #6092fd">
                      {{ row.asin | defaultShow }}
                    </el-row>
                    <el-row>
                      {{ row.msku | defaultShow }}
                    </el-row>
                  </div>
                </template>
              </gj-table>
            </div>
          </div>
          <div class="gj-picker__table">
            <div class="tagAndMemo">标签和备注</div>
            <el-form ref="form" :model="form" label-width="135px">
              <el-form-item label="已选标签：" class="setting-wrapper">
                <span v-for="(item, index) in tagList" :key="index">
                  <gj-tag
                    :color="tagColors.orange"
                    type="plain"
                    :closable="true"
                    @close="close(item)"
                    >{{ item.text }}</gj-tag
                  >
                </span>
                <div v-if="tableData[selected]">
                  <!-- <gj-select
                    v-model="tableData[selected].tagIds"
                    :options="options"
                    placeholder="请选择标签"
                    type="multi-check"
                    width="150px"
                    :key="selected"
                    :filterable="false"
                  ></gj-select> -->
                  <tag-cascader v-model="tableData[selected].tagIds"></tag-cascader>
                  <span
                    class="setting-icon"
                    v-if="$permission('tag:view')"
                    @click="$router.push({ path: '/crm/tag-manager' })"
                  >
                    <gj-icon class="el-icon-setting"></gj-icon>
                  </span>
                </div>
              </el-form-item>
              <el-form-item label="备注：" prop="desc" style="margin-bottom: 0">
                <gj-textarea
                  v-if="tableData[selected]"
                  v-model="tableData[selected].memo"
                  :styles="{ height: '120px', width: '400px' }"
                >
                </gj-textarea>
              </el-form-item>
            </el-form>
          </div>
        </el-row>
      </template>
    </template>
  </gj-modal>
</template>

<script>
import {
  modalMixIn,
  formRuleMixin,
  responseMixin,
  isMeaningfulMixin,
  queryMixin,
  isMeaninglessMixin,
} from '../../../../minxins';
import { getActiveTag, saveTagToListing } from '../../../../api/common';
import { getListingTag } from '../../../../api/sale';
import { isMeaningful, isMeaningless, unique } from '../../../../utils/common';
import { tagColors } from '@/components/tag/tag-colors';
import  tagCascader  from '@/components/cascader/gj-tag-cascader'
export default {
  name: 'app-tag-edit-modal',
  components:{tagCascader},
  mixins: [
    modalMixIn,
    formRuleMixin,
    responseMixin,
    isMeaningfulMixin,
    queryMixin,
    isMeaninglessMixin,
  ],
  props: {
    tag: {
      required: true,
    },
  },
  data() {
    return {
      tagOptionsTree: [],
      value: [],
      tagColors,
      confirmLoading: false,
      options: [],
      columns0: [
        {
          id: 'picture',
          header: '图片',
          field: 'picture:imageUrl',
          width: '60px',
        },
        {
          id: 'listingTitle',
          header: '商品标题/ASIN/MSKU',
          field: 'slot:listingTitle',
          minWidth: '180px',
        },
      ],
      tableData: [],
      isMeaningful: isMeaningful,
      selected: 0,
      loading: true,
      selectTagList: [],
      form: {},
      productAsin: null,
    };
  },
  created() {
    this.getListingTag();
    this.queryData();
  },
  computed: {
    tagList() {
      if (!this.tableData[this.selected]) {
        return [];
      }
      const arr = [];
      for (const index in this.tableData[this.selected].tagIds) {
        for (const index1 in this.options) {
          if (this.tableData[this.selected].tagIds[index] == this.options[index1].id) {
            arr.push(this.options[index1]);
          }
        }
      }
      return arr;
    },
  },
  watch: {
    productAsin: {
      deep: true,
      immediate: true,
      handler: function () {
        this.queryData();
      },
    },
    $route: {
      immediate: true,
      handler(to, from) {
        if (from?.path === '/crm/tag-manager') {
          this.queryData();
        }
      },
    },
  },
  methods: {
    clickRow(row, column, event) {
      this.selected = row.rowIndex;
      this.productAsin = row.row.asin;
    },
    queryData() {
      this.loading = true;
      const params = {
        module: 'Feedback',
        // fid: this.tag.id,
        orderId: this.tag.orderId,
        asin: this.productAsin,
      };
      getActiveTag(params)
        .then((res) => {
          this.options = res;
        })
        .complete(() => (this.loading = false));
    },
    getListingTag() {
      this.loading = true;
      getListingTag(this.tag.orderId, 'Feedback', this.tag.marketId)
        .then((data) => {
          if (isMeaningful(data)) {
            this.tableData = data.map((e) => ({
              ...e,
              listingTitle: e.title,
            }));
            this.$refs.gjTable.setCurrentRow(this.tableData[0]);
            this.productAsin = this.tableData[0] && this.tableData[0].asin;
          } else {
            this.tableData = [];
          }
        })
        .complete(() => (this.loading = false));
    },

    // 删除标签
    close(tag) {
      const arr = this.tableData[this.selected].tagIds.filter((item, index) => {
        if (item != tag.id) {
          return item;
        }
      });
      this.tableData[this.selected].tagIds = arr;
    },

    confirm() {
      this.confirmLoading = true;
      const params = {
        fid: this.tag.id,
        marketId: this.tag.marketId,
        module: 'Feedback',
        orderId: this.tag.orderId,
        tagAndAsinDTOList: this.tableData,
      };
      saveTagToListing(params)
        .then((res) => {
          this.$gjResponseHandle(res, () => {
            this.$gjMessage.success('编辑标签成功');
            this.$emit('created');
            this.$gjDestroy();
          });
        })
        .complete(() => {
          this.confirmLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
// @import "picker";
.marBottom {
  margin-bottom: 15px;
}
.boldSpan {
  font-weight: bold;
  color: #333;
  display: inline-block;
}
.tagAndMemo {
  color: #606266;
  font-size: 12px;
  font-weight: bold;
  line-height: 39px;
  height: 39px;
  border-bottom: 1px solid #e8eaec;
  box-sizing: border-box;
  margin-bottom: 20px;
  padding-left: 20px;
}
/deep/ .el-col-2 {
  width: 6.5%;
}
.gj-picker__editor {
  width: 450px;
  padding: 0;
  // border: 1px solid #e1e1e1;
}
.gj-picker__table {
  width: calc(100% - 450px);
  border: 1px solid #d8dadd;
  border-left: 0;
}
.el-tag /deep/ .el-tag__close {
  color: rgb(255, 153, 0);
}
.el-tag /deep/ .el-tag__close:hover {
  color: #fff;
  background-color: rgb(255, 153, 0);
}
/deep/.gj-modal--table .el-dialog {
  height: 560px;
}
.setting-icon {
  font-size: 16px;
  margin-left: 4px;
  display: none;
  cursor: pointer;
}
.setting-wrapper:hover .setting-icon {
  display: inline;
  line-height: 1;
}
.gj-picker__editor--body /deep/ .vxe-table--border-line {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
/deep/ .vxe-table--render-default .vxe-body--row.row--current {
  background: #edf7ff;
}
/deep/ .el-dialog__body {
  padding-bottom: 0;
}
</style>
